function PlacesAPI(inputId, opts) {
  const googleMaps = window.google.maps;
  this.opts = opts;
  this.inputId = inputId;
  this.ac = new googleMaps.places.Autocomplete(
    document.getElementById(inputId),
    this.opts || {}
  );
}

function onPlaceSelected(handlePlaceSelected) {
  const ac = this.ac;
  const inputId = this.inputId;
  const googleMaps = window.google.maps;

  googleMaps.event.addListener(ac, 'place_changed', () => {
    const { place_id: placeId, geometry } = ac.getPlace();

    if (placeId) {
      const placeObj = {
        lat: geometry.location.lat(),
        lng: geometry.location.lng(),
        name: document.getElementById(inputId).value,
        placeId
      };

      handlePlaceSelected(placeObj);
    }
  });
}

PlacesAPI.prototype.onPlaceSelected = onPlaceSelected;

export default PlacesAPI;
